import { basicInfoHandlers } from "./common/basicInfo/basicInfoHandlers";
import { laborCostHandlers } from "./common/laborCost/laborCostHandler";
import { orderHandlers } from "./purchase/orderHandlers";
import { bomHandlers } from "./stock/bom/bomHandlers";
import { inboundHandlers } from "./stock/inbound/inboundHandlers";
import { outboundHandlers } from "./stock/outbound/outboundHandlers";
import { stockProductsHandlers } from "./stock/product/stockProductsHandlers";
export const handlers = [
    ...orderHandlers,
    ...inboundHandlers,
    ...outboundHandlers,
    ...basicInfoHandlers,
    ...laborCostHandlers,
    ...stockProductsHandlers,
    ...bomHandlers,
];
